import { render, staticRenderFns } from "./OpenBankingDescriptionStep.vue?vue&type=template&id=58d9a992&scoped=true"
import script from "./OpenBankingDescriptionStep.vue?vue&type=script&lang=js"
export * from "./OpenBankingDescriptionStep.vue?vue&type=script&lang=js"
import style0 from "./OpenBankingDescriptionStep.vue?vue&type=style&index=0&id=58d9a992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d9a992",
  null
  
)

export default component.exports